/** Space and product keys: 2 to 10 chars, uppercase letter first, then uppercase letters or digits. */
export const KEY_PATTERN = /^[A-Z][A-Z0-9]{1,9}$/;
const ITEM_KEY = /^([A-Za-z][A-Za-z0-9]{1,9})-(\d{1,9})$/;

export function isValidKey(key: string): boolean {
  return KEY_PATTERN.test(key);
}

export function formatItemKey(productKey: string, number: number): string {
  return `${productKey}-${number}`;
}

/** Parses "PLZ-123" (case-insensitive) into its parts; returns null for anything else. */
export function parseItemKey(value: string): { productKey: string; number: number } | null {
  const m = ITEM_KEY.exec(value.trim());
  if (!m) return null;
  const number = Number(m[2]);
  if (number < 1) return null;
  return { productKey: m[1]!.toUpperCase(), number };
}

/** Normalizes user input to the canonical key form, or null when it is not an item key. */
export function normalizeItemKey(value: string): string | null {
  const parsed = parseItemKey(value);
  return parsed ? formatItemKey(parsed.productKey, parsed.number) : null;
}
